// Stage 7+ — keyboard shortcuts are now registered through the command
// registry (src/input/shortcutRegistry.ts), which the palette driver installs
// as a single global keydown listener. This file used to own a 70-line switch
// over `e.code`; that role moved to the registry so adding a hotkey in one
// place also lights up the ⌘K palette and the help-panel Shortcuts tab.
//
// What remains here is the one shortcut whose action is *not* a store intent:
// the colorbar collapse toggle is a DOM-level operation owned by the colorbar
// widget, exposed via the deps bag. We register it through the registry like
// every other command and return its un-register as the cleanup.

import { getShortcutRegistry } from './shortcutRegistry';
import type { ParamsState } from '../store/schema';

export interface KeyboardCtx {
    params: ParamsState;
    keys: Record<string, boolean>;
    toggleColorbarCollapse?: () => void;
}

export function initKeyboardShortcuts(ctx: KeyboardCtx): () => void {
    const registry = getShortcutRegistry();
    const offs: Array<() => void> = [];

    if (typeof ctx.toggleColorbarCollapse === 'function') {
        const callback = ctx.toggleColorbarCollapse;
        offs.push(registry.register({
            id: 'colorbar.toggleCollapse',
            label: 'Toggle colorbar collapse',
            category: 'View',
            aliases: ['colourbar', 'legend'],
            keys: ['M'],
            allowWhileTyping: true,
            run: () => { callback(); },
        }));
    }

    // `params` and `keys` are kept on the ctx contract because callers still
    // thread them through (camera flight + selection cube polling read the
    // raw key state from `viewer.input.keys`, set by keyboard.ts). Nothing
    // in this module reads them anymore.
    void ctx.params;
    void ctx.keys;

    return () => {
        for (const off of offs) {
            try { off(); } catch { /* swallow */ }
        }
    };
}
